module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/victory-window-73fdea.svg";